import { DATA_KIND } from '../../../model/enums';
import { FunctionObj } from '../../../vo/workingdata/function-obj';
import { MeasModeItem } from '../measure.mode.obj';
import { WizDateUtils } from '@wizeoo/akm-core-lib';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { Model } from '../../../model/model';
/**
 * fonctions sur dates
 */
export class DateFunctions {


  public static functions(model: Model): FunctionObj[] {
    const funcArr: FunctionObj[] = [];
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'DATEADD', [DATA_KIND.DATE, DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'DATEDIFF', [DATA_KIND.DATE, DATA_KIND.DATE]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'TODAY', [DATA_KIND.NUMBER]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'TODATE', [DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'DAY', [DATA_KIND.DATE]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'MONTH', [DATA_KIND.DATE]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'YEAR', [DATA_KIND.DATE]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'FORCEDAY', [DATA_KIND.DATE, DATA_KIND.NUMBER]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'WEEK', [DATA_KIND.DATE]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'CHINESEZODIAC', [DATA_KIND.DATE]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'ZODIAC', [DATA_KIND.DATE]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'NOW', [DATA_KIND.NUMBER]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'TIMEADD', [DATA_KIND.STRING, DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'TIMEDIFF', [DATA_KIND.STRING, DATA_KIND.STRING]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'FULLTIMEAGG', [DATA_KIND.DATE, DATA_KIND.STRING]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'FULLTIMEADD', [DATA_KIND.DATE, DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'FULLTIMEDIFF', [DATA_KIND.DATE, DATA_KIND.DATE, DATA_KIND.STRING]));
    funcArr.push(new FunctionObj(model, FunctionObj.KIND_DATE, 'TARGETDAY', [DATA_KIND.DATE, DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
    return funcArr;
  }

  /**
   * date du jour
   * @param mmi Etape de calcul concernée
   */
  public static TODAY(mmi: MeasModeItem): void {
    const res = WizDateUtils.dateToString(WizDateUtils.TODAY);
    mmi.r = res;
  }

  /**
   * date du jour avec heure min sec
   * @param mmi Etape de calcul concernée
   */
  public static NOW(mmi: MeasModeItem): void {
    const res = WizDateUtils.dateToString(WizDateUtils.TODAY, WizDateUtils.FULL_MASK);
    mmi.r = res;
  }

  /**
   * ajout sur une date
   * @param mmi Etape de calcul concernée
   */
  public static DATEADD(mmi: MeasModeItem): void {
    const date: MeasModeItem = mmi.c[0]; // la date
    let year: number = Number(mmi.c[1].r); // nb années
    let month: number = Number(mmi.c[2].r); // nb mois
    let day: number = Number(mmi.c[3].r); // nb jours

    let result: any = null;

    // contrôle de cohérence
    if (date.isErr) {
      //mmi.r = null; //date.r;

      mmi.isErr = true;
    } else {
      if (!year) {
        year = 0;
      }
      if (!month) {
        month = 0;
      }
      if (!day) {
        day = 0;
      }

      if (!year && !month && !day ) { // tout a nul, on fait rien...
        mmi.r = date.r;
      } else {
        if (date.r) {
          mmi.isErr = false;
          try {
            result = WizDateUtils.add(Number(date.r), {days: day, months: month, years: year});
          } catch (e: any) {
            // console.log('bad date', mmi.measureMode);
          }
        }
      }
    }


    if (!!result) {
      mmi.r = result.toString();
    } else {
      mmi.r = null;
    }

  }

  /**
   * retourne l'écart en jours entre 2 dates
   * @param mmi Etape de calcul concernée
   */
  public static DATEDIFF(mmi: MeasModeItem): void {
    const dateDeb: MeasModeItem = mmi.c[0]; // la date
    const dateEnd: MeasModeItem = mmi.c[1]; // la date

    // contrôle de cohérence
    if (dateDeb.isErr || dateEnd.isErr) {
      mmi.r = null;
      mmi.isErr = true;
    } else {
      if (dateDeb.r && dateEnd.r) {
        try {
          mmi.isErr = false;
          const start: Date = WizDateUtils.stringToDate(dateDeb.r);
          const end: Date = WizDateUtils.stringToDate(dateEnd.r);
          let res = WizDateUtils.dayDiff(end, start);

          if (start > end) {
            res = -res;
          }
          if (!!res) {
            mmi.r = res.toString();
          } else {
            mmi.r = null;
          }

        } catch (e: any) {

        }

      }
    }
  }


  /**
   * construit une date depuis 3 params YYYY MM DD
   * @param mmi Etape de calcul concernée
   */
  public static TODATE(mmi: MeasModeItem): void {
    const year: number = Number(mmi.c[0].r); // année
    const month: number = Number(mmi.c[1].r); // mois
    const day: number = Number(mmi.c[2].r); // jours

    // contrôle de cohérence
    if (!year || !month || !day) {
      mmi.r = null;
      mmi.isErr = true;
    } else {
      let strDate: string = year.toString();
      if (month < 10) {
        strDate += '0';
      }
      strDate += month.toString();
      if (day < 10) {
        strDate += '0';
      }
      strDate += day.toString();
      // const res = WizDateUtils.stringToDate(strDate);
      mmi.r = strDate;
    }
  }

  /**
   * extrait le numéro de semaine pour une date
   * @param mmi Etape de calcul concernée
   */
  public static WEEK(mmi: MeasModeItem): void {
    const srcDate: MeasModeItem = mmi.c[0]; // la date
    try {
      mmi.r = WizDateUtils.weekNumber(srcDate.r)[0].toString();
    }catch (e: any) {
      mmi.r = null;
    }
  }

  /**
   * retourne le signe astrologique
   * @param mmi Etape de calcul concernée
   */
  public static ZODIAC(mmi: MeasModeItem, fei: FeiVO): void {
    const srcDate: MeasModeItem = mmi.c[0]; // la date
    let result = null;
    try {
      const parts: string[] = this.dateSplitter(srcDate?.r);
      const month: string = parts[1]; // le mois commence à 1
      const day: string = parts[2]; // le jour est sur 2 digits, c'est bien
      const monthNum: number = Number(month); // on commence à 1 pour les mois
      const fullNum: number = Number(month + '.' + day); // mon indice véritable

      // 1		Capricorne
      // 2		Verseau
      // 3		Poissons
      // 5		Taureau
      // 6		Gémeaux
      // 7		Cancer
      // 8		Lion
      // 9		Vierge
      // 10		Balance
      // 11		Scorpion
      // 12		Sagittaire
      const reference: number[] = [1.20, 2.19, 3.21, 4.20, 5.21, 6.21, 7.23, 8.23, 9.23, 10.23, 11.22, 12.22]; // les points de bascule
      if (monthNum > 0) {
        let idx = monthNum; // mon indice dans le tableau
        if (reference[idx - 1] < fullNum) { // je suis au delà du point de bascule pour mon mois
          idx++; // je suis du signe suivant
        }
        if (idx > 12 ) { // sagittaire, de janvier...
          idx = 1;
        }
        result = fei.model.localeEngine.translateKey('$.zodiac.' + idx + '.$');
      }
    }catch (e: any) {
    }
    mmi.r = result;
  }

  /**
   * retourne le signe astrologique chinois selon l'année
   * @param mmi Etape de calcul concernée
   */
  public static CHINESEZODIAC(mmi: MeasModeItem, fei: FeiVO): void {
    const srcDate: MeasModeItem = mmi.c[0]; // la date cible
    let result: string = null;
    try {
      const parts: string[] = this.dateSplitter(srcDate?.r);
      const year: number = Number(parts[0]) - 4;
      if (year > 0) {
        const idx = year % 12;
        result = fei.model.localeEngine.translateKey('$.zodiac.chinese.' + idx + '.$');
      }
    }catch (e: any) {
    }

    mmi.r = result;

  }

  /**
   * extrait le jour d'une date (sur 2 digits)
   * @param mmi Etape de calcul concernée
   */
  public static DAY(mmi: MeasModeItem): void {
    const srcDate: MeasModeItem = mmi.c[0]; // la date

    const parts: string[] = this.dateSplitter(srcDate?.r);
    mmi.r = parts[2];
  }


  /**
   * extrait le mois d'une date (sur 2 digits)
   * @param mmi Etape de calcul concernée
   */
  public static MONTH(mmi: MeasModeItem): void {
    const srcDate: MeasModeItem = mmi.c[0]; // la date

    const parts: string[] = this.dateSplitter(srcDate?.r);
    mmi.r = parts[1];
  }

  /**
   * extrait l'année d'une date
   * @param mmi Etape de calcul concernée
   */
  public static YEAR(mmi: MeasModeItem): void {
    const srcDate: MeasModeItem = mmi.c[0]; // la date

    const parts: string[] = this.dateSplitter(srcDate?.r);
    mmi.r = parts[0];
  }

  /**
   * force le jour sur une date
   * 1er param, la date
   * 2eme param, le jour
   * @param mmi Etape de calcul concernée
   */
  public static FORCEDAY(mmi: MeasModeItem): void {
    const srcDate: MeasModeItem = mmi.c[0]; // la date
    const srcDay: MeasModeItem = mmi.c[1]; // le jour à forcer


    const parts: string[] = this.dateSplitter(srcDate?.r);
    const dayAsNum: number = Number(srcDay?.r);
    const realDay: string = dayAsNum < 10 ? '0' + dayAsNum.toString() : dayAsNum.toString();

    parts[2] = realDay;
    mmi.r = parts.join('');
  }



  /** décomposition d'une date YYYYMMDD en ses constituants */
  private static dateSplitter(srcDate: string): string[] {
    const res: string[] = [null, null, null];
    const realDate: Date = WizDateUtils.numberToDate(Number(srcDate));
    if (!!realDate) { // contrôle de cohérence
      res[0] = srcDate.substring(0, 4);
      res[1] = srcDate.substring(4, 6);
      res[2] = srcDate.substring(6, 8);
    }

    return res;
  }

  /**
   * ajout de temps à une heure
   * @param mmi Etape de calcul concernée
   */
  public static TIMEADD(mmi: MeasModeItem): void {
    const time: MeasModeItem = mmi.c[0]; // la date
    let hour: number = Number(mmi.c[1].r) || 0; // nb heures
    let minute: number = Number(mmi.c[2].r) || 0; // nb minutes
    let second: number = Number(mmi.c[3].r) || 0; // nb secondes

    // contrôle de cohérence
    if (time.isErr) {
      mmi.r = time.r;
      mmi.isErr = true;
    } else {
      
      if (!hour && !minute && !second ) { // tout a nul, on fait rien...
        mmi.r = time.r;
      } else {
        if (time.r) {
          mmi.isErr = false;
          let res = null;
          try {
            res = WizDateUtils.timeAdd(time.r, hour, minute, second);
          } catch (e: any) {
          }


          if (!!res) {
            mmi.r = res.toString();
          } else {
            mmi.r = null;
          }
        }
      }
    }
  }

  /**
   * retourne l'écart en secondes entre 2 heures
   * @param mmi Etape de calcul concernée
   */
  public static TIMEDIFF(mmi: MeasModeItem): void {
    const dateStart: MeasModeItem = mmi.c[0]; // l'heure de début
    const dateEnd: MeasModeItem = mmi.c[1]; // l'heure de fin

    // contrôle de cohérence
    if (dateStart.isErr || dateEnd.isErr) {
      mmi.r = null;
      mmi.isErr = true;
    } else {

      let res = WizDateUtils.timeDiff(dateEnd.r, dateStart.r);
      mmi.r = res.toString();
    }
  }

  /**
   *  assemble une date et un heure
   * @param mmi Etape de calcul concernée
   */
  public static FULLTIMEAGG(mmi: MeasModeItem): void {
    const datePart: MeasModeItem = mmi.c[0]; // la date YYYYMMDD
    const hourPart: MeasModeItem = mmi.c[1]; // l'heure HHmmss

    // contrôle de cohérence
    if (datePart.isErr || hourPart.isErr || !datePart.r) {
      mmi.r = null;
      mmi.isErr = true;
    } else {
      let res = [WizDateUtils.dateToEight(datePart.r), WizDateUtils.hourToSix(hourPart.r)].join('');
      // console.log('FULLTIMEAGG',datePart.r, hourPart.r, res);
      mmi.r = res.toString();
    }
  }

  /**
   * ajout de temps à une heure
   * @param mmi Etape de calcul concernée
   */
  public static FULLTIMEADD(mmi: MeasModeItem): void {
    const time: MeasModeItem = mmi.c[0]; // la date avec éventuellement des heures
    let years: number = Number(mmi.c[1]?.r) || 0; // nb années
    let months: number = Number(mmi.c[2]?.r) || 0; // nb mois
    let days: number = Number(mmi.c[3]?.r) || 0; // nb jours
    let hours: number = Number(mmi.c[4]?.r) || 0; // nb heures
    let minutes: number = Number(mmi.c[5]?.r) || 0; // nb minutes
    let seconds: number = Number(mmi.c[6]?.r) || 0; // nb secondes

    // contrôle de cohérence
    if (time.isErr) {
      mmi.r = time.r;
      mmi.isErr = true;
    } else {
      
      if (!years && !months && !days && !hours && !minutes && !seconds ) { // tout a nul, on fait rien...
        mmi.r = time.r;
      } else {
        if (time.r) {
          mmi.isErr = false;
          let res: string = null;
          try {
            res = WizDateUtils.fullTimeAdd(time.r, {years, months, days, hours, minutes, seconds});
          } catch (e: any) {
          }

          if (!!res) {
            mmi.r = res;
          } else {
            mmi.r = null;
          }
        }
      }
    }
  }

  /**
   * retourne l'écart en secondes entre 2 heures
   * @param mmi Etape de calcul concernée
   */
  public static FULLTIMEDIFF(mmi: MeasModeItem): void {
    const dateStart: MeasModeItem = mmi.c[0]; // l'heure de début
    const dateEnd: MeasModeItem = mmi.c[1]; // l'heure de fin
    const format: string = mmi.c[2]?.r || 's'; // format smh
    // contrôle de cohérence
    if (dateStart.isErr || dateEnd.isErr) {
      mmi.r = null;
      mmi.isErr = true;
    } else {
      let res = WizDateUtils.fullTimeDiff(dateStart.r, dateEnd.r, format);
      mmi.r = res?.toString() || null;
    }
  }

  /**
   * cherche le prochain jour proche de la date (1=lundi, 2=mardi)
   * 1er param, la date
   * 2eme param, le jour 1 (lundi)-7(dimanche)
   * 3eme param le sens (suivant = 1, précédent = -1, proche = 0)
   * @param mmi Etape de calcul concernée
   */
  public static TARGETDAY(mmi: MeasModeItem): void {
    const srcDate: string = mmi.c[0].r; // la date
    const srcDay: number = Number(mmi.c[1].r); // le jour à forcer
    const way: number = Number(mmi.c[2].r);

    // input
    let date: Date = WizDateUtils.stringToDate(srcDate);

    // jour identifié (jour de la même semaine)
    let day: Date | number = WizDateUtils.weekDates(date, srcDay, 1)[0];

    if(way !== 0) {
      let delta: number = Number(WizDateUtils.dateToNumber(day) - WizDateUtils.dateToNumber(date));
      if(delta <0 && way === 1) {// on veut le suivant mais on a le précédent
        day = WizDateUtils.add(day, {days: 7});
      } else if(delta > 0 && way === -1) {// on veut le précédent mais on a le suivant
        day = WizDateUtils.add(day, {days: -7});
      }
    }
    
    // gestion du sens -1, 0 , 1
    // console.log('delta', srcDate, WizDateUtils.dateToString(day), delta);

    mmi.r = WizDateUtils.dateToString(day as Date);
  }


}
